module.exports = __webpack_public_path__ + "static/media/DZW_03.b3960d88.jpg";